module.exports = __webpack_public_path__ + "img/violet_144.e0e9d349.png";